import Vue from 'vue'
import { supportedLanguages, parseParameters } from '@/utils/common'
// Import Bootstrap and BootstrapVue CSS files (order is important)
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Import I18n
import VueI18n from 'vue-i18n'
import en from '@/locales/en.json'
import de from '@/locales/de.json'
import es from '@/locales/es.json'
import fr from '@/locales/fr.json'
import it from '@/locales/it.json'
import ja from '@/locales/ja.json'
import ko from '@/locales/ko.json'
import pl from '@/locales/pl.json'
import pt from '@/locales/pt.json'
import ru from '@/locales/ru.json'
import zh_cn from '@/locales/zh-cn.json'
import zh_tw from '@/locales/zh-tw.json'
// Import D2TZ components
import App from './App.vue'
import Blog from './Blog.vue'
import Home from './Home.vue'
import NotificationApps from './NotificationApps.vue'
import ExpCalculator from './ExpCalculator.vue'
import PrivacyPolicy from './PrivacyPolicy.vue'
import TermsOfService from './TermsOfService.vue'
import AboutUs from './AboutUs.vue'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// Use internationalization plugin
Vue.use(VueI18n)

Vue.config.productionTip = false

// Router config
const routes = {
  '/': Home,
  '/introduction': Blog,
  '/blog': Blog,
  '/online': App,
  '/offline': App,
  '/apps': NotificationApps,
  '/exp': ExpCalculator,
  '/privacy': PrivacyPolicy,
  '/terms': TermsOfService,
  '/about': AboutUs,
}

// Create i18n instance
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'en',
  fallbackLocale: 'en',
  messages: {
    de,
    en,
    "en-us": en,
    es,
    fr,
    it,
    ja,
    ko,
    pl,
    pt,
    "pt-br": pt,
    ru,
    "zh-cn": zh_cn,
    "zh-tw": zh_tw,
  },
})

// Init main app view
new Vue({
  data: {
    currentRoute: window.location.pathname
  },
  computed: {
    ViewComponent () {
      const paramStr = window.location.search;
      if (paramStr?.length > 0) {
        const params = parseParameters(paramStr);
        if (!!params['l'] && supportedLanguages.includes(params['l'])) {
          return App
        }
      }
      return routes[this.currentRoute] || App
    }
  },
  i18n,
  render (h) {
    return h(this.ViewComponent)
  }
}).$mount('#app')
